import React, { useEffect, useState } from "react";

import { Button, Box, Typography, Chip, Stack } from "@mui/material";
import { WarehouseConnection } from "@domain/inventory/models/WarehouseConnection";
import { APP_CONFIG } from "../../../../config/app.config";
import { MoreVert } from "@mui/icons-material";
import { useConnections } from "@features/connections/generic/hooks/useConnections";
import { WarehouseConnectionType } from "@domain/inventory/enums/WarehouseConnectionType.enum";
import { Connector } from "@domain/connection/models/Connector";
import { RuleField } from "@domain/inventory/enums/RuleField.enum";

interface DefaultWarehouseConnectionButtonProps {
    connection: WarehouseConnection;
    onEditConnection: (connection: WarehouseConnection) => void;
}


export const DefaultWarehouseConnectionButton = ({ connection, onEditConnection }: DefaultWarehouseConnectionButtonProps) => {


    const { connectors } = useConnections();

    const [connector, setConnector] = useState<Connector | undefined>(undefined);

    useEffect(() => {
        const connector = connectors?.find(connector => connector.type as string === connection.sourceType);
        setConnector(connector);
    }, [connectors]);


    return (
        <Stack direction="row" key={connection.id} sx={{ p: 3, display: 'flex', gap: 2, alignItems: 'center', '&:hover': { backgroundColor: 'transparent' } }}>


            <Box sx={{ display: 'flex', border: `1px solid ${APP_CONFIG.ui.theme.colors.border}`, borderRadius: 1, width: 100, height: 70 }}>
                <img src={connector?.image} alt={connection.sourceType} style={{ width: '100%', objectFit: 'contain' }} />
            </Box>

            <Stack>

                <Typography variant="subtitle2" color="text.primary" gutterBottom>{connection.sourceType} - {connection.mutationType}</Typography>


                {connection.rules.filter(rule => rule.field !== RuleField.CONNECTION_ID).map((rule) => (
                    <Stack direction="row" key={rule.field} sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <Chip key={rule.field} label={`${rule.field}: ${rule.value}`} color="primary" size="small" />
                    </Stack>
                ))}


            </Stack>
        </Stack>
    );

};